<template lang="html">
  <b-container class="admin-page">
    <div>


      <div class="sezione-utente-corrente" v-if="current_user != '[object Promise]' && current_user.type == 'partner' ">
        <div class="dati-utente">
          <div class="immagine-utente">
            <div class="immagine-profilo">
              +
            </div>
          </div>

          <div class="user-data">
            <div class="info-personali">
              <div class="riga-dati">
                <span class="light-gray">Nome:</span>
                {{current_user.name}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Cognome:</span>
                {{current_user.surname}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Azienda:</span>
                {{current_user.company}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Mail:</span>
                {{current_user.email}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Telefono:</span>
                {{current_user.phone_number}}
              </div>

            </div>
            <div class="info-posizione">
              <div class="riga-dati">
                <span class="light-gray">Indirizzo:</span>
                {{current_user.addr_street}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Città:</span>
                {{current_user.addr_city}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">CAP:</span>
                {{current_user.addr_zip}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Provincia:</span>
                {{current_user.addr_prov}}
              </div>

            </div>
          </div>
        </div>
        <div class="statistiche-utente">
          <div class="">
            Numero annunci inserirti <br>
          </div>
          <div class="">
            Alberi salvati:
          </div>
          <div class="">
            Emissioni CO2 evitate
          </div>
        </div>


      </div>



      <!-- {{current_user}} -->
      <div class="mb-5">
        <b-button @click="form={}" variant="primary">
          Aggiungi un utente
        </b-button>
      </div>
      <div class="row riga-paginazione" v-if="$store.user.type == 'admin'">
        <div class="col-md-4">
          <b-pagination v-if="users && users.last_page > 1"
            :total-rows="users.total"
            :per-page="users.per_page"
            first-text="<<"
            prev-text="<"
            next-text=">"
            last-text=">>"
            v-model="page"
            />
        </div>
        <div class="col-md-4">
          <div class="region-search">
            <div class="filter-title">
              Regione
            </div>
            <b-form-select v-model="filters.region" :options="region_options">
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="user-search">
            <div class="search-company">
              <b-form-input class="input-search" v-model="filters.searched_value" debounce="400" placeholder="Cerca un azienda"></b-form-input>
              <!-- <button class="btn btn-primary"  @click="refreshUsers">Cerca</button> -->
            </div>
          </div>
        </div>
      </div>


      <div class="table table-hover table-responsive table-striped  dataTable">
        <table class="user-table w-100">
          <thead>
            <tr>
              <th>Azienda</th>
              <th>Nome</th>
              <th>Email</th>
              <th>Indirizzo</th>
              <th>Telefono</th>
              <th>Ruolo</th>
              <th v-if="$store.user.type == 'admin'">Data inserimento</th>

              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!users">
              <td colspan="100%">
                Caricamento...
              </td>
            </tr>
            <tr v-else-if="!users.total">
              <td colspan="100%">
                Nessun Utente
              </td>
            </tr>
            <tr v-for="user in (users || {}).data" :key="user.id" class="pointer" @click="form = _.cloneDeep(user)">
              <td v-text="user.company"/>
              <td v-text="user.name+' '+user.surname"/>
              <td v-text="user.email"/>
              <td>
                <span class="text-spaced" style="color:#81bb5d" v-text="user.region"></span><br>
                <span class="text-spaced" style="color:#f18973" v-text="user.addr_zip"></span>
                <span class="text-spaced" style="color:#f18973" v-text="user.addr_prov"></span><br>
                <span class="text-spaced" v-text="user.addr_street"></span>
                <span class="text-spaced" v-text="user.addr_city"></span>
              </td>
              <td v-text="user.phone_number"/>
              <td v-text="user.type"/>
              <th v-if="$store.user.type == 'admin'" v-text="user.created_at" />
              <td>
                <b-icon class="text-danger ml-2" icon="trash" @click.stop="deleteUser(user.id)"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row paginazione-finale">
        <div class="col-md-12">
          <b-pagination v-if="users && users.last_page > 1"
            :total-rows="users.total"
            :per-page="users.per_page"
            first-text="<<"
            prev-text="<"
            next-text=">"
            last-text=">>"
            v-model="page"
            />
        </div>
      </div>


    </div>

    <b-modal :visible="!!form" @hidden="form = null" hide-footer hide-header size="lg">
      <user-form v-if="form" :form="form" @saved="refreshUsers()" @close="form=null"/>
    </b-modal>
  </b-container>
</template>

<script>
import UserForm from '@/components/user-form'

export default {
  components: {
    UserForm,
  },

  data() {
    return {
      users: null,
      page: 1,
      form: null,
      show: true,
      showDeleteModal: true,
      current_user : null,
      filters: {},
      region_options: [
        { value: null, text: 'Tutte'},
        { value: 'Abruzzo', text: 'Abruzzo'},
        { value: 'Basilicata', text: 'Basilicata'},
        { value: 'Calabria', text: 'Calabria'},
        { value: 'Campania', text: 'Campania'},
        { value: 'Emilia-Romagna', text: 'Emilia-Romagna'},
        { value: 'Friuli-Venezia Giulia', text: 'Friuli-Venezia Giulia'},
        { value: 'Lazio', text: 'Lazio'},
        { value: 'Liguria', text: 'Liguria'},
        { value: 'Lombardia', text: 'Lombardia'},
        { value: 'Marche', text: 'Marche'},
        { value: 'Molise', text: 'Molise'},
        { value: 'Piemonte', text: 'Piemonte'},
        { value: 'Puglia', text: 'Puglia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Sicilia', text: 'Sicilia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Toscana', text: 'Toscana'},
        { value: 'Trentino-Alto Adige', text: 'Trentino-Alto Adige'},
        { value: 'Umbria', text: 'Umbria'},
        { value: "Val d'aosta", text: "Val d'aosta"},
        { value: 'Veneto', text: 'Veneto'}
      ]
    }
  },

  created() {
    this.refreshUsers();
    this.get_current_user_data()
  },
  methods: {
    // refreshUsers() {
    //   if(this.search_value != null || this.region_selected != null){
    //     this.refreshUsers()
    //   }else {
    //     let params = {
    //       page: this.page,
    //     }
    //     this.$http.get('users', {
    //       params
    //     }).then(res => {
    //       this.users = res.data
    //     })
    //   }
    // },
    refreshUsers(){
      let params = Object.assign({
        page: this.page,
      }, this.filters)

      this.$http.get('users', {
        params
      }).then(res => {
        console.log(params)
        this.users = res.data
      })
    },
    get_current_user_data(){
      this.current_user = this.$http.get('self').then(res => {
        this.current_user = res.data
      })
    },
    deleteUser(id) {
      if (!confirm('Sicuro?')) return null
      this.$http.delete('users/' + id).then(() => {
        this.refreshUsers()
      })
    }


  },
  watch: {
    page() {
      this.refreshUsers()
    },
    filters: {
      deep: true,
      handler() {
        this.refreshUsers()
      }
    }
  }


}
</script>

<style lang="scss">
  .immagine-profilo{
    height:200px;
    width: 200px;
    border:1px solid black;
  }
  .dati-utente{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }
  .user-data{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    padding-left: 30px;
    width: 100%;

  }
  .info-personali{
    padding-right:100px;
  }
  .light-gray{
    color: #ccc;
  }
  .statistiche-utente{
    padding-bottom:60px;
  }
  .riga-dati{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border-bottom:1px solid #ccc;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .info-personali{
    width: 100%;
  }
  .info-posizione{
    width: 100%;
  }
  .immagine-profilo{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:40px;
    border-radius: 20px;
    cursor: pointer;
  }
  .statistiche-utente{
    padding-top:40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  .sezione-utente-corrente{
    padding-top:40px;
  }
  .text-spaced{
    padding-right:4px;
  }
  .user-table{
    padding-bottom:80px;
  }
  .paginazione-finale{
    padding-bottom: 100px;
  }
  .user-search{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction:column;
  }
  .search-company{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction:row;
    width: 100%;
  }
  .region-search{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction:row;
  }
  .pagination{
    margin:0px;
  }
  .riga-paginazione{
    padding-bottom:30px;
  }
  .input-search{
    max-width:200px;
  }
  .filter-title{
    padding-right:10px;
  }
</style>
